import React from "react";
import { components } from "react-select";
import { UseFormSetValue } from "react-hook-form";

export const customSelectComponents = {
  MultiValue: (props: any) => {
    if (props.data?.value === "ALL") {
      return React.createElement(
        "div",
        {
          style: {
            color: "#212529",
            fontSize: "12px",
            padding: "0 2px",
            fontWeight: "400",
            whiteSpace: "nowrap",
          },
        },
        props.data.label
      );
    }
    return React.createElement(components.MultiValue, props);
  },
};

export const getCustomSelectStyles = (hasError: boolean, isAllSelected: boolean) => ({
  control: (base: any, state: any) => ({
    ...base,
    minHeight: "25px",
    height: "auto",
    borderColor: hasError ? "#dc3545" : state.isFocused ? "#86b7fe" : base.borderColor,
  }),
  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
  valueContainer: (base: any) => ({
    ...base,
    padding: "0 6px",
    fontSize: "12px",
  }),
  input: (base: any) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  indicatorsContainer: (base: any) => ({
    ...base,
    height: "25px",
  }),
  clearIndicator: (base: any) => ({
    ...base,
    display: isAllSelected ? "none" : "flex",
  }),
  option: (base: any, state: any) => ({
    ...base,
    fontSize: "12px",
    padding: "6px 10px",
    height: "25px",
    display: "flex",
    alignItems: "center",
    backgroundColor: state.isSelected
      ? "#1e6b91"
      : state.isFocused
        ? "#e6f0ff"
        : "white",
    color: state.isSelected ? "white" : "black",
  }),
});

export const handleAllMultiSelectChange = (
  fieldName: string,
  selected: any,
  currentVals: (string | number)[],
  setValue: UseFormSetValue<any>
) => {
  if (!selected || selected.length === 0) {
    setValue(fieldName, ["ALL"], { shouldValidate: true, shouldDirty: true });
    return;
  }
  const selectedValues = selected.map((opt: any) => opt.value);
  const hadAll = currentVals.includes("ALL");
  const hasAll = selectedValues.includes("ALL");

  if (!hadAll && hasAll) {
    setValue(fieldName, ["ALL"], { shouldValidate: true, shouldDirty: true });
  } else if (hadAll && hasAll && selectedValues.length > 1) {
    setValue(fieldName, selectedValues.filter((val: any) => val !== "ALL"), {
      shouldValidate: true,
      shouldDirty: true,
    });
  } else {
    setValue(fieldName, selectedValues, {
      shouldValidate: true,
      shouldDirty: true,
    });
  }
};

export const sanitizeSingleFilterVal = (
  val: string | number | null | undefined
): string | null => {
  if (!val || val === "ALL") return null;
  return String(val);
};

export const sanitizeMultiFilterVal = (
  vals: (string | number)[] | string | number | null | undefined
): string[] | null => {
  if (!vals) return null;
  if (Array.isArray(vals)) {
    const filtered = vals.filter((v) => v !== "ALL").map(String);
    return filtered.length > 0 ? filtered : null;
  }
  if (vals === "ALL") return null;
  return [String(vals)];
};
